<template>
  <f7-card>
    <f7-card-header>
      <strong>{{ $t('groupImport.member') }} {{ index + 1 }}</strong>
      <f7-button fill
        v-if="!isSingle"
        color="red"
        @click="$emit('remove')"
      >
        {{ $t('groupImport.remove') }}
      </f7-button>
    </f7-card-header>
    <f7-card-content>
        <f7-list form>
          <f7-list-input
            :value="modelValue.firstName"
            @input="modelValue.firstName = $event.target.value"
            :label="$t('groupImport.firstName')"
            type="text"
            required
          />
          <f7-list-input
            :value="modelValue.lastName"
            @input="modelValue.lastName = $event.target.value"
            :label="$t('groupImport.lastName')"
            type="text"
            required
          />
          <f7-list-input
            ref="phoneInputRef"
            :value="modelValue.phoneNumber"
            @input="modelValue.phoneNumber = $event.target.value"
            :label="$t('groupImport.phoneNumber')"
            type="tel"
          />
          <f7-list-input
            :value="modelValue.email"
            @input="modelValue.email = $event.target.value"
            :label="$t('groupImport.email')"
            type="email"
          />
        </f7-list>
      <div v-if="modelValue.errors?.length" class="text-color-red validation-errors">
        {{ modelValue.errors.join(', ') }}
      </div>
    </f7-card-content>
  </f7-card>
</template>

<script setup>
import { ref, watch, onMounted, onUnmounted } from 'vue';
import { useTelephone } from '../js/composables/useTelephone.js';

const props = defineProps({
  modelValue: Object,
  index: Number,
  isSingle: Boolean
});

const emit = defineEmits(['update:modelValue', 'remove']);

const phoneInputRef = ref(null);

// Initialize useTelephone
const { phoneData } = useTelephone(phoneInputRef);

// Sync phoneData changes back to the member object
watch(phoneData, (newData) => {
  if (newData.number !== props.modelValue.phoneNumber) {
    emit('update:modelValue', { ...props.modelValue, phoneNumber: newData.number });
  }
});
</script>

<style scoped>
.validation-errors {
  font-size: 12px;
  padding: 4px 4px 0;
}
</style>
